import axiosSso from "@/api/interceptor_sso";

// 获取oem配置
export function postToolsWebConfig(data: any) {
  return axiosSso.post(`/agent/tools/web-config`, data);
}

// 批量文件上传
export function postToolsFileBatchUpload(data: any) {
  return axiosSso.post(`/agent/tools/file-batch-upload`, data);
}

// 备注列表
export function getRemarks(params: any) {
  return axiosSso.get("/agent/remarks", { params });
}

// 创建备注
export function postRemarks(data: any) {
  return axiosSso.post(`/agent/remarks`, data);
}